import { Injectable } from '@angular/core';
import { Converter } from '@spartacus/core';
import { ArticleService } from '../../catalog';
import { Article, ArticlePrice, Unit, VolumeDiscount } from '../../model';
import { Occ } from '../../occ';

@Injectable({ providedIn: 'root' })
export class ArticlePriceNormalizer implements Converter<Occ.PriceResponse, ArticlePrice> {
  constructor(private articleService: ArticleService) {}

  convert(source: Occ.PriceResponse, target?: ArticlePrice): ArticlePrice {
    if (source) {
      const { unit: unitCode, volumeDiscount, ...src } = source;

      // we "should" have the article in our store already, otherwise unit lookup will fail
      let article: Article;
      this.articleService
        .getArticle(src.articleNumber)
        .subscribe((data) => (article = data))
        .unsubscribe();

      const unit = this.getUnitFromArticleByUnitCode(article, unitCode) ?? { code: unitCode };
      return {
        ...src,
        unit,
        ...(volumeDiscount?.scalePrices?.some((scalePrice) => scalePrice?.scaleDiscountPercent > 0)
          ? {
              volumeDiscount: this.convertVolumeDiscount(
                volumeDiscount,
                source.quantity,
                this.getUnitFromArticleByUnitCode(article, source.unit),
                article
              ),
            }
          : {}),
      };
    }

    return target;
  }

  private convertVolumeDiscount(source: Occ.VolumeDiscount, quantity?: number, unit?: Unit, article?: Article): VolumeDiscount {
    const quantityInEcommerceUnit = quantity !== undefined && unit !== undefined ? quantity * unit.inEcommerceUnit : undefined;

    const scalePriceUnit = this.getUnitFromArticleByUnitCode(article, source.scalePriceUnit) ?? { code: source.scalePriceUnit };
    const scaleUnit = this.getUnitFromArticleByUnitCode(article, source.scaleUnit) ?? { code: source.scalePriceUnit };

    return {
      ...source,
      scalePriceUnit,
      scaleUnit,
      scalePrices: source.scalePrices?.map((scalePrice, i, scalePrices) => ({
        ...scalePrice,
        active:
          !!scaleUnit && quantityInEcommerceUnit !== undefined
            ? quantityInEcommerceUnit >= scalePrice.scaleQuantity * scaleUnit?.inEcommerceUnit &&
              (i >= scalePrices.length - 1
                ? true
                : quantityInEcommerceUnit < scalePrices?.[i + 1].scaleQuantity * scaleUnit?.inEcommerceUnit)
            : undefined,
      })),
    };
  }

  private getUnitFromArticleByUnitCode(article: Article, unitCode: string): Unit {
    return article?.units?.find((u) => u.locSymbol === unitCode || u.code === unitCode);
  }
}
